import { useAuthSelector } from 'app/data/auth';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { sdk } from 'app/sdk';
import { GroupsPageResponse } from 'types/group';
import { UsersPageResponse } from 'types/user';
import groupQueryKeys from './groupQueryKeys';
interface QueryParams {
  skip?: number;
  take?: number;
  orderBy?: any;
  filters?: any;
  options?: Omit<
    UseQueryOptions<GroupsPageResponse, Error, GroupsPageResponse, QueryKey>,
    'queryKey' | 'queryFn'
  >;
}

export const useListGroupsQuery = ({
  skip = 0,
  take = 10000,
  orderBy = [['name', 'asc']],
  filters = {},
  options,
}: QueryParams) => {
  // returns list of groups
  // - just get ALL groups+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = groupQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<GroupsPageResponse, Error>(
    queryKey,
    () =>
      sdk.group.query.groups(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      ...options,
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,
      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListGroupsQuery;
